import { PageBody, ResponsiveContainer } from "ui";
import { PageWithHeaderAndFooter } from "@web/components/containers/PageWithHeaderAndFooter";
import { PostDataWithHtml } from "@web/types/blog/PostDataWithHtml";
import styles from "./css/BlogPostPage.module.css";
import { BlogHeader } from "@web/pages/blog/BlogHeader";

type Props = {
  postData: PostDataWithHtml;
};

export function BlogPostPage({ postData }: Props) {
  return (
    <PageWithHeaderAndFooter
      header={
        <div>
          <ResponsiveContainer>
            <BlogHeader />
          </ResponsiveContainer>
        </div>
      }
    >
      <PageBody header={postData.title}>
        <div
          className={styles.content}
          dangerouslySetInnerHTML={{ __html: postData.contentHtml }}
        />
      </PageBody>
    </PageWithHeaderAndFooter>
  );
}
